import React from 'react';
import classNameBind from 'classnames/bind';
import Button from '../../../../Button';
import styles from './styles.module.css';

const bindClasses = classNameBind.bind(styles);

const Navbar = ({
  onPreviousClick,
  onNextClick,
  showPreviousButton,
  showNextButton,
  className,
}) => (
  <div className={bindClasses(className, 'wrapper')} data-ppuc-id="DatePicker.Navbar">
    <div className={bindClasses('prev')} data-ppuc-id="DatePicker.Navbar.previous">
      <Button
        icon="arrow-left"
        disabled={!showPreviousButton}
        onClick={() => onPreviousClick()}
      />
    </div>
    <div className={bindClasses('next')} data-ppuc-id="DatePicker.Navbar.next">
      <Button icon="arrow-right" disabled={!showNextButton} onClick={() => onNextClick()} />
    </div>
  </div>
);

export default Navbar;
